export const mediaScreenSizes = {
  tablet: '1279px',
  mobile: '743px',
  mobileSmall: '360px',
};

export const screenSizes = {
  tablet: 1279,
  mobile: 743,
  mobileSmall: 360,
};
